import { render } from "./CreateDocumentModal.vue?vue&type=template&id=750bec40&scoped=true"
import script from "./CreateDocumentModal.vue?vue&type=script&lang=js"
export * from "./CreateDocumentModal.vue?vue&type=script&lang=js"

import "./CreateDocumentModal.vue?vue&type=style&index=0&id=750bec40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-750bec40"]])

export default __exports__